import jump from '../utils/jump';
export function needLoginHandler(data) {
  if (data.code === '400') {
    jump.toPage('5');
    return;
  }
  return data;
}
